import avito from "../../vendor/avito.svg";
import yandex from "../../vendor/yandex.svg";
import vk from "../../vendor/vk.svg";

const SourceIcons = ({ sources, size = 25 }) => {
  const getIconPath = (source) => {
    const icons = {
      avito,
      yandex,
      vk,
    };
    return icons[source] || null;
  };

  const getDisplayName = (source) => {
    const names = {
      avito: "Авито",
      yandex: "Яндекс",
      vk: "ВКонтакте",
    };
    return names[source] || source;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        width: "max-content",
        padding: "5px",
      }}
    >
      {Object.entries(sources)
        .filter(([_, count]) => count > 0)
        .map(([source, count]) => (
          <div
            key={source}
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <img
              src={getIconPath(source)}
              alt={getDisplayName(source)}
              style={{
                width: size,
                height: size,
                borderRadius: "2px",
              }}
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.marginLeft = "0";
              }}
            />
            <span style={{ fontSize: "18px", color: "#333" }}>
              {count}&nbsp;
            </span>
          </div>
        ))}
    </div>
  );
};

export default SourceIcons;
